import React from 'react';
import { RangeContainer } from '../../QuestionType/rangeContainer';
import { FormProvider, useForm } from 'react-hook-form';

function RatingResult({ result }) {
  const methods = useForm();
  return (
    <FormProvider {...methods}>
      {result?.resultAnswers?.map((field, index) => (
        <RangeContainer
          key={index}
          isDisabled={true}
          startValue={field?.answer}
          position={index}
          option={field?.option}
          label={{ ...field?.label }}
          value={{ ...field?.value }}
          SurveyOption={field?.SurveyOption}
          isStarImage={true}
        />
      ))}
    </FormProvider>
  );
}

export default RatingResult;
